// extracted by mini-css-extract-plugin
module.exports = {"CatalogueItemCard":"CatalogueItemCard_CatalogueItemCard__3ccAD","dsc":"CatalogueItemCard_dsc__1zsnp"};